import { render, staticRenderFns } from "./Video.vue?vue&type=template&id=360c620d&scoped=true"
import script from "./Video.vue?vue&type=script&lang=js"
export * from "./Video.vue?vue&type=script&lang=js"
import style0 from "./Video.vue?vue&type=style&index=0&id=360c620d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "360c620d",
  null
  
)

export default component.exports